import React from 'react';
import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';

const breakpoints = { tablet: 768, phone: 480 };

const BannerContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  max-width: 1100px;
  margin: 0px auto 0;
  padding: 12px 48px;
  background-color: ${({ colors }) => colors.successBannerBackground || '#3FA34D'};
  color: ${({ colors }) => colors.successBannerText || '#FFFFFF'};
  border: 2px solid ${({ colors }) => colors.successBannerBorder || '#2C7A36'};
  // border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 12px 40px;
    margin-top: 14px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    padding: 10px 36px 10px 12px;
    gap: 10px;
    margin-top: 12px;
  }
`;


const Message = styled.span`
  font-size: 1rem;
  font-weight: 600;
  text-align: center;

  @media (max-width: ${breakpoints.phone}px) {
    font-size: 0.9rem;
  }
`;

const DismissButton = styled.button`
  position: absolute;
  top: 8px;
  right: 12px;
  background: transparent;
  border: none;
  color: inherit;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;

  &:hover,
  &:focus {
    opacity: 0.85;
  }
`;

export default function LoginSuccessBanner({ colors, message = 'You are successfully logged in.', onDismiss }) {
  return (
    <BannerContainer colors={colors} role="status" aria-live="polite">
      {/* <IconWrapper aria-hidden="true">
        <FaCheckCircle />
      </IconWrapper> */}
      <Message>{message}</Message>
      {/* {onDismiss && (
        <DismissButton
          type="button"
          // onClick={onDismiss}
          aria-label="Dismiss login status message"
        >
          x
        </DismissButton>
      )} */}
    </BannerContainer>
  );
}
